import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { aboutInfo } from '@/mocks/about';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HomeCategories from './components/HomeCategories';
import HomeArticles from './components/HomeArticles';
import HomeFAQ from './components/HomeFAQ';
import HomeCTA from './components/HomeCTA';

export default function Home() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '鲍鱼网址域名导航',
      url: 'https://baoyu.com',
      description: '鲍鱼网址域名官方入口导航平台，提供最新域名入口、安全访问验证及注册登录指南',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://baoyu.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    });
    document.head.appendChild(script);

    const orgScript = document.createElement('script');
    orgScript.type = 'application/ld+json';
    orgScript.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '鲍鱼网址域名导航',
      url: 'https://baoyu.com',
      description: aboutInfo.introduction.substring(0, 150),
      contactPoint: {
        '@type': 'ContactPoint',
        email: aboutInfo.contact.email,
        contactType: 'customer service',
      },
    });
    document.head.appendChild(orgScript);

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '鲍鱼网址域名是什么？',
          acceptedAnswer: { '@type': 'Answer', text: '鲍鱼网址域名是用户快速访问鲍鱼平台的官方通道，由鲍鱼平台官方管理和维护。通过官方域名，用户可以安全地访问鲍鱼平台进行注册、登录和使用各项服务。' },
        },
        {
          '@type': 'Question',
          name: '如何确认当前访问的是鲍鱼官方网站？',
          acceptedAnswer: { '@type': 'Answer', text: '检查浏览器地址栏是否有安全锁图标；核对网址拼写是否与官方公布的域名完全一致；查看网站底部是否有ICP备案号；通过官方APP或客服渠道核实。' },
        },
      ],
    });
    document.head.appendChild(faqScript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(orgScript);
      document.head.removeChild(faqScript);
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full h-[500px] md:h-[650px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20elegant%20abstract%20ocean%20wave%20with%20pearl%20shell%20texture%20in%20soft%20coral%20and%20cream%20tones%2C%20minimalist%20luxurious%20background%20with%20gentle%20gradient%20and%20flowing%20organic%20shapes%2C%20clean%20modern%20aesthetic%2C%20soft%20lighting%2C%20no%20text%2C%20high%20resolution&width=1920&height=1080&seq=hero-baoyu-main&orientation=landscape"
            alt="鲍鱼域名导航背景"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
          <div className="relative z-10 w-full text-center px-4">
            <div className="max-w-3xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
                <div className="w-2 h-2 rounded-full bg-accent-400"></div>
                <span className="text-xs text-background-50/90 font-medium">官方认证 · 实时更新 · 安全可靠</span>
              </div>
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
                鲍鱼网址域名 — 官方入口导航与注册指南
              </h1>
              <p className="mt-4 text-background-50/75 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
                整合最新鲍鱼网址域名入口、域名防丢失方案、安全验证方法及注册登录全流程，帮助您随时找到正确地址，避免访问钓鱼域名风险
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link
                  to="/category/domain-entry"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/30 whitespace-nowrap"
                >
                  <i className="ri-global-line"></i> 查看最新域名入口
                </Link>
                <Link
                  to="/category/security-access"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap"
                >
                  <i className="ri-shield-check-line"></i> 安全访问指南
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Quick Stats */}
        <section className="px-4 md:px-6 py-10 bg-background-50 border-b border-background-200/70">
          <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
            {aboutInfo.reputation.map((item) => (
              <div key={item.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{item.value}</div>
                <div className="mt-1 text-xs text-foreground-500">{item.label}</div>
              </div>
            ))}
          </div>
        </section>

        <HomeCategories />
        <HomeArticles />
        <HomeFAQ />
        <HomeCTA />
      </main>
      <Footer />
    </>
  );
}